import React, { useEffect } from 'react';
import { MainTable } from '../../../Components/MainTable/MainTable';
import { useManufacturer } from './ManufacturerStore';
import Add from './Add';
import Edit from './Edit';

function Manufacturer(props) {
    let { manufacturers, columns, getManufacturer, deleteManufacturer,  setEd } = useManufacturer();
    useEffect(() => {
        getManufacturer()
    }, [])
    return (
        <MainTable
            pageTitle='Ishlab chiqaruvchilar'
            pcolumns={columns}
            pdata={manufacturers}
            add={<Add />}
            edit={<Edit />}
            defkey={'id'}
            onDelete={(e, rec) => {
                deleteManufacturer(rec.id)
            }}
            onEdit={(rec) => {
                setEd(rec)
            }}
            setEd={setEd}
        />
    );
}

export default Manufacturer;